export const GA_MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();

export function isGaEnabled() {
  return Boolean(GA_MEASUREMENT_ID && typeof window !== "undefined" && typeof window.gtag === "function");
}

export function trackPageView(path, title) {
  if (!isGaEnabled()) return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!isGaEnabled()) return;
  window.gtag("event", eventName, params);
}
